import {state} from './state.js';

export const UPDATE_ID = (State, id) => {
    State.currentId = parseInt(id)
};

export const SET_POPUP = (State, data) => {
    State.popup = data
};

export const SET_FORM = (State, isActive) => {
    State.isActive = isActive;
};

export const SET_SCROLL_PERCENTAGE = (State, scrollPercentage) => {
    State.scrollPercentage = scrollPercentage;
};


// WEBPACK FOOTER //
// ./src/store/mutations.js